// extracted by mini-css-extract-plugin
export default {"itemWrapper":"news-category-module--itemWrapper--fxyIQ"};